import type { FaireProductEntity } from "../../entity_types/product";

export const p_te9qznykma: FaireProductEntity = {
  token: "p_te9qznykma",
  type: "product",
  name: "Thank You Florals Behind Open Envelope Thank You Card",
  brandToken: "b_qat8n5mmyf",
  brandName: "Willow & Ivy Press",
  imageUrl:
    "https://cdn.faire.com/fastly/8b0b95054f0e19a1f284f67d426527574231e03ed025f7e46eb6b10c617dd669.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a18c4d6e65499baa41a93e3d70be46ff829a5dd1029107b90340dd6484f6b0a.png",
  ],
  priceDollars: 18,
  description:
    "Willow & Ivy Greeting Cards print on heavy, uncoated paper stock with foil, glitter, and die-cut embellishments. Each card includes a Champagne Gold Pearlized envelope for a timeless look and touch. All cards are made in the USA.\n\n6 Cards & Envelopes per unit\nWholesale: $18.00/unit\nRetail: $6.00 eachWillow & Ivy Greeting Cards print on heavy, uncoated paper stock with foil, glitter, and die-cut embellishments. Each card includes a Champagne Gold Pearlized envelope for a timeless look and touch. All cards are made in the USA.\n\n6 Cards & Envelopes per unit\nWholesale: $18.00/unit\nRetail: $6.00 each                                                       Please note: Cards are not individually cello-wrapped and include the retail price printed on the back.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:10.095Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
